import { TApplicationState } from '../../types/redux';
import { getNewbuildingId } from '../newbuilding';

export function selectDefaultProductsData(state: TApplicationState) {
  const newbuildingId = getNewbuildingId(state);

  return {
    id: newbuildingId,
    offerType: 'JK',
    position: 1,
  };
}
